import React from "react";
import { OrderTypes } from "shared/api/types/pagination";
import ChevronDownIcon from "shared/components/icons/chevron/ChevronDownIcon";
import ChevronUpIcon from "shared/components/icons/chevron/ChevronUpIcon";
import { PillarTableBaseColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";
import { PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";

const OrderTypeAscending = () => <ChevronUpIcon className="w-2 h-2" />;
const OrderTypeDescending = () => <ChevronDownIcon className="h-2 w-2" />;

const PillarTableHeaderOrderBy = <
  RowGeneric = PillarTableSafeAny,
  ExtraPropsGeneric = PillarTableSafeAny | undefined,
  InlineEditFormGeneric = PillarTableSafeAny | undefined,
>(
  props: PillarTableBaseColumnProps<
    RowGeneric,
    ExtraPropsGeneric,
    InlineEditFormGeneric
  >,
) => {
  const context = usePillarTableContext<
    RowGeneric,
    ExtraPropsGeneric,
    InlineEditFormGeneric
  >();

  if (!props.orderByKey) {
    return <></>;
  }
  const currentOrderByKeyMatches =
    context?.paginationState?.orderByKey === props.orderByKey;
  const orderType =
    (context?.paginationState?.orderType as OrderTypes) ?? OrderTypes.asc;
  if (currentOrderByKeyMatches && orderType === OrderTypes.desc) {
    return <OrderTypeDescending />;
  }

  return <OrderTypeAscending />;
};

export default PillarTableHeaderOrderBy;
